import styled, { keyframes } from "styled-components"
import {
    FormGroup,
    Button,
} from "client/components"

const maxWidth = 400
const top = 130
const ShakeAnim = keyframes`
    0%, 100% { transform: translateX(0px); }
    20% { transform: translateX(-20px); }
    40% { transform: translateX(20px); }
    60% { transform: translateX(-15px); }
    80% { transform: translateX(15px); }
`
export const AuthWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.defaultTextColor};
    background: ${(props) => props.theme.loginPageBackground};
`
export const AuthTitle = styled.h1`
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 15px;
`
export const AuthFormWrapper = styled.div<{
    show: boolean
}>`
    position: absolute;
    top: ${top}px;
    left: ${(props) => (props.show ? "50%" : 0)};
    opacity: ${(props) => (props.show ? 1 : 0)};
    transform: translateX(-50%);
    transition: 0.4s ease;
`
export const SuccessfulAuthWrapper = styled.div<{
    show: boolean
}>`
    position: absolute;
    top: ${top}px;
    left: ${(props) => (props.show ? "50%" : "100%")};
    opacity: ${(props) => (props.show ? 1 : 0)};
    transform: translateX(-50%);
    transition: 0.4s ease;
`
export const AuthForm = styled.div`
    position: relative;
    width: ${maxWidth}px;
    padding: 0 15px;

    & > ${FormGroup} > .feedback {
        margin-left: 5px;
    }
`
export const AuthFormDescription = styled.div`
    width: 100%;
    margin-top: 25px;
    margin-bottom: 15px;
`
export const AuthInput = styled.input`
    width: 100%;
    height: 45px;
    padding: 6px 12px 6px 20px;
    margin-bottom: 8px;
    box-sizing: border-box;
    border: none;
    outline: none;
    font-weight: bold;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.loginInputColor};
    background: ${(props) => props.theme.loginInputBackground};

    &:focus {
        color: ${(props) => props.theme.loginInputFocusColor};
    }

    &::placeholder {
       color: ${(props) => props.theme.loginInputPlaceholderColor};
    }
`
export const AuthButton = styled(Button)`
    width: 100%;
    margin-top: 15px;
`
export const AuthLinkWrapper = styled.div`
    padding: 0 10px;
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
`
export const AuthLink = styled.a`
    font-weight: 600;
    color: ${(props) => props.theme.loginLinkColor};

    &:hover {
        color: ${(props) => props.theme.loginLinkActiveColor};
    }
`
export const LoginLinkWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 50px;
`
export const LoginLink = styled.a`
    font-size: 18px;
    font-weight: bold;
    color: ${(props) => props.theme.goToLoginLinkColor};

    &:hover, &:active {
        color: ${(props) => props.theme.goToLoginLinkActiveColor};
    }
`

// sign in

export const SignInForm = styled(AuthForm)<{
    shake?: boolean
    animLength?: number
}>`
    animation: ${ShakeAnim} ${(props) => props.shake && `${props.animLength}ms linear infinite`};

    &::after {
        content: "";
        display: block;
        height: 2px;
        width: 100%;
        position: absolute;
        top: 45px;
        left: 34px;
        background: ${(props) => props.theme.loginPageBackground};
    }

    & > .feedback {
        position: absolute;
        top: calc(100% + 20px);
        left: 25px;
    }
`
export const SignInInput = styled(AuthInput)`
    margin-bottom: 0;

    &[name="username"] {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    &[name="password"] {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
`
export const SignInButton = styled.button`
    position: absolute;
    height: 50px;
    width: 52px;
    padding: 6px 8px;
    top: 22px;
    left: calc(100% - 40px);
    z-index: 1;
    outline: none;
    border-radius: 50%;
    background: ${(props) => props.theme.loginInputBackground};
    border: 5px solid ${(props) => props.theme.loginPageBackground};
    color: ${(props) => props.theme.loginInputColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.defaultTextColor};
        text-shadow: 0 0 6px ${(props) => props.theme.defaultTextColor};
    }

    & > i {
        font-size: 16px;
    }
`

// account list

export const AccountListWrapper = styled.div`
    max-width: ${maxWidth}px;
    margin: 0 auto;
    user-select: none;
    overflow: hidden;
    border-radius: 8px;
    background: ${(props) => props.theme.loginInputBackground};
`
export const AccountList = styled.div`
    height: 380px;
    overflow-y: scroll;
    overflow-x: hidden;
`
export const AccountItem = styled.div<{
    active: boolean
}>`
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 8px 12px;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.loginPageBackground};
    box-shadow: inset 0 0 10px ${(props) => (props.active ? props.theme.loginBoxShadowColor : "transparent")};
    transition: box-shadow ${(props) => props.theme.defaultTransition};
    background: transparent;

    &:last-child {
        border-bottom: none;
    }
`
export const AccountInfo = styled.div`
    cursor: default;
    width: 280px;
    margin-bottom: 8px;
    margin-left: 15px;
`
export const AccountName = styled.div`
    overflow: hidden;
`
export const ConfirmAccount = styled.div<{
    show: boolean
}>`
    height: 22px;
    font-style: italic;
    font-weight: 100;
    transform: translateY(${(props) => (props.show ? 0 : 15)}px);
    opacity: ${(props) => (props.show ? 1 : 0)};
    color: ${(props) => props.theme.loginAccountConfirm};
    transition: 0.4s ease;
`
